'use client';

import MediaContainer from '@/components/MediaContainer';
import CloudImage from '@/components/CloudImage';
import { cityImages } from '@/constants/images';

export default function CityBanner({ cityBannerImageUrl }) {
  return (
    <section className="border-primary laptop:h-[30vh] relative h-[20vh] w-full overflow-hidden rounded border-[0.25rem]">
      {/* Background Image */}
      <CloudImage
        publicId={cityBannerImageUrl}
        alt="City Banner Background"
        fill
        className="z-0 object-cover"
      />

      {/* Foreground Logo Image, pinned to the left edge */}
      <MediaContainer className="border-primary absolute top-0 left-0 z-10 aspect-square h-full max-w-[25%] border-r-[0.25rem] bg-white">
        <CloudImage
          publicId={cityImages.bannerLogo.publicId}
          alt={cityImages.bannerLogo.alt}
          objectFit="contain"
        />
      </MediaContainer>
    </section>
  );
}
